import React, { useEffect, useState } from 'react';
import { GeoJSON, MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const continentDefaults = {
    africa: { center: [0, 20], zoom: 3 },
    asia: { center: [34, 100], zoom: 3 },
    europe: { center: [54, 15], zoom: 4 },
    'north america': { center: [40, -100], zoom: 3 },
    'south america': { center: [-15, -60], zoom: 3 },
    oceania: { center: [-25, 135], zoom: 3 }
};

const ContinentMap = ({ selectedContinent, onCountryClick, countryLookup }) => {
    const [geoData, setGeoData] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const continentKey = selectedContinent ? selectedContinent.toLowerCase() : '';
    const defaultView = continentDefaults[continentKey] || { center: [54, 15], zoom: 4 };

    useEffect(() => {
        if (!selectedContinent) return;
        setIsFetching(true);
        const slug = selectedContinent.toLowerCase().replace(/\s+/g, '_');
        fetch(`/data/continent/${slug}.json`)
            .then((res) => res.json())
            .then((data) => {
                data.features = data.features.filter((feature) => feature.geometry);
                data.features = data.features.map((feature) => {
                    feature.properties.countryName =
                        feature.properties.NAME || feature.properties.name || feature.properties.NAME_LONG || 'Unknown';
                    return feature;
                });

                setGeoData(data);
                setIsFetching(false);
            })
            .catch((err) => {
                console.error('Error fetching continent geoJSON', err);
                setIsFetching(false);
            });
    }, [selectedContinent]);

    const onEachFeature = (feature, layer) => {
        if (!feature.properties) return;

        const candidateNames = [
            feature.properties.countryName,
            feature.properties.NAME,
            feature.properties.BRK_NAME,
            feature.properties.name
        ].filter(Boolean);

        const matchedCountry = candidateNames
            .map((name) => countryLookup[name.toLowerCase()])
            .find((country) => country !== undefined);

        const countryIdentifier = matchedCountry ? matchedCountry.name : candidateNames[0] || 'Unknown';

        layer.bindPopup(countryIdentifier);
        layer.on('click', () => {
            onCountryClick(countryIdentifier);
        });
    };

    return (
        <MapContainer
            key='continent'
            center={defaultView.center}
            zoom={defaultView.zoom}
            style={{ height: '100%', width: '100%' }}
            maxBounds={[
                [-85.05112878, -180],
                [85.05112878, 180]
            ]}
            maxBoundsViscosity={1.0}
            worldCopyJump={false}
            zoomControl={false}
        >
            <TileLayer
                attribution='&copy; OpenStreetMap contributors'
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            <ZoomControl position='topright' />
            {geoData && (
                <>
                    <GeoJSON
                        data={geoData}
                        onEachFeature={onEachFeature}
                        style={{
                            color: '#607D8B',
                            weight: 1,
                            fillColor: '#ECEFF1',
                            fillOpacity: 0.5
                        }}
                    />
                </>
            )}
        </MapContainer>
    );
};

export default ContinentMap;
